import { popUrl } from '../lib/pops';

/** Un pop, l'avatar di un agente: sempre libero, senza cerchio attorno. */
export function Pop({ avatar, size, label }: { avatar: string; size: number; label?: string }) {
  return (
    <img
      src={popUrl(avatar)}
      alt={label ?? ''}
      width={size}
      height={size}
      draggable={false}
      style={{ width: size, height: size, objectFit: 'contain', flex: 'none' }}
    />
  );
}
